import { useLocation, useParams } from 'react-router-dom'

import { Text } from '@factorialco/deprecated-design-system'
import {
  DeleteSubprojectDocument,
  ProjectManagementProjectDetailsPageDeleteSubprojectModalPageDocument,
  SubprojectsDataCollectionDocument,
} from 'generated/resources/graphql'

import { useMutation } from 'modules/core/hooks/useMutation'
import { useQuery } from 'modules/core/hooks/useQuery'
import { track, trackingEvents } from 'modules/core/lib/Tracking'
import i18n from 'modules/core/lib/i18n'

import DeleteSubrojectModal from 'modules/project_management/components/modals/SoftDeleteModal'

const DeleteSubprojectModalPage = () => {
  const { subprojectId, id } = useParams()
  const projectId = String(id)

  const { state } = useLocation()
  const { subprojectName } = state || { subprojectName: '' }
  const { data, loading: loadingQuery } = useQuery(
    ProjectManagementProjectDetailsPageDeleteSubprojectModalPageDocument,
    {
      variables: {
        projectId,
      },
    }
  )
  const canDeleteSubproject =
    data?.projectManagement.project?._policies?.subprojectEdit?.can ?? false

  const [deleteSubproject, { loading: loadingDelete }] = useMutation(DeleteSubprojectDocument, {
    extractorFn: (mutation) =>
      mutation.projectManagementMutations.deleteProjectmanagementSubproject,
    refetchQueries: [SubprojectsDataCollectionDocument],
    awaitRefetchQueries: true,
  })

  if (!canDeleteSubproject || loadingQuery) return null

  const onSubmit = () => {
    track(trackingEvents.projectManagement.subprojects.deletePhaseSubmit, {
      project_id: projectId,
    })

    return deleteSubproject({
      variables: {
        id: String(subprojectId),
      },
    })
  }

  const description = (
    <Text size="300">
      {i18n.tView('project_management.modals.delete_subproject.description', {
        project_name: (
          <Text size="300" weight="bold">
            {subprojectName}
          </Text>
        ),
      })}
    </Text>
  )

  return (
    <DeleteSubrojectModal
      onSubmit={onSubmit}
      loading={loadingDelete}
      title={i18n.t('project_management.modals.delete_subproject.title')}
      description={description}
      iconName={'delete-cross'}
      inputLabel={i18n.t('project_management.modals.delete_subproject.input_label')}
      submitButtonLabel={i18n.t('project_management.modals.delete_subproject.submit')}
    />
  )
}

export default DeleteSubprojectModalPage
